// import { CssBaseline, Button } from "@mui/material";
import React, { useEffect, useState } from "react";

import { BrowserRouter as Router, Route } from "react-router-dom";

import "./output.css";
import Cover from "./components/Cover";
import Opening from "./components/Opening";
import TentangKami from "./components/TentangKami";
import Surat from "./components/Surat";
import Jadwal from "./components/Jadwal";
import Lokasi from "./components/Lokasi";
import Time from "./components/Time";
import Galeri from "./components/Galeri";
import Rsvp from "./components/Rsvp";
import Himbauan from "./components/Himbauan";
import LoveStory from "./components/LoveStory";
import music from "./assets/music.mp3";
import { Howl } from "howler";
import Aos from "aos";
import "aos/dist/aos.css";
import { BsFillPlayFill } from "react-icons/bs";
import { GiPauseButton } from "react-icons/gi";

function App() {
  const [slide, setSlide] = useState(false);
  const [isPlaying, setIsPlaying] = useState(true);
  const [audio] = useState(
    new Howl({
      src: music,

      onend: function () {
        setIsPlaying(false);
      },
    })
  );

  useEffect(() => {
    audio.play();
    Aos.init({ duration: 3000 });
  }, []);

  const audioPlayer = () => {
    console.log("1");
    if (isPlaying) {
      console.log("2");
      setIsPlaying(false);
      audio.pause();
    } else {
      console.log("3");
      setIsPlaying(true);
      audio.play();
    }
  };

  return (
    <Router>
      <Route to="/">
        <div className={`${slide ? "" : "h-[100vh] w-full "} `}>
          <div
            onClick={audioPlayer}
            className="fixed bottom-5 right-5  sm:bottom-10 sm:right-10 hover:bg-gray-700 cursor-pointer   bg-black p-3 rounded-full z-30"
          >
            {isPlaying ? (
              <GiPauseButton color="white" size="1.5rem" />
            ) : (
              <BsFillPlayFill color="white" size="1.5rem" />
            )}
          </div>
          <Cover slide={slide} setSlide={setSlide} />
          <div className="font-noto text-gray-700 flex flex-col space-y-12 ">
            <Opening />
            <TentangKami />
            <LoveStory />
            <Surat />
            <Jadwal />
            <Lokasi />
            <Time />
            <Galeri />
            <Rsvp />
            <Himbauan />
          </div>
        </div>
      </Route>
    </Router>
  );
}

export default App;
